import { ArrowRightIcon } from 'lucide-react'

import { SideCard } from './SideCard'
import type { Side } from './types'

// Shared by every confirmation on the page, so a page move reads like an edit. No text goes lighter
// than neutral-600: "From" differs from "To" by its label and place, not by fading.

export const FromTo = ({
  label,
  from,
  to,
}: {
  label: string | null
  from: Side
  to: Side
}) => (
  <div className="space-y-1.5">
    {label ? (
      <p className="text-sm font-medium text-neutral-950">{label}</p>
    ) : null}
    <div className="flex items-stretch gap-2">
      <div className="flex min-w-0 flex-1 flex-col gap-1.5">
        <SideCard label="From" side={from} landing={false} />
      </div>
      <ArrowRightIcon className="size-4 shrink-0 self-center text-neutral-600" />
      <div className="flex min-w-0 flex-1">
        <SideCard label="To" side={to} landing />
      </div>
    </div>
  </div>
)
